"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCoreLogger = exports.Level = void 0;
/**
 * The log level
 */
var Level;
(function (Level) {
    Level["Info"] = "info";
    Level["Warn"] = "warn";
    Level["Error"] = "error";
})(Level = exports.Level || (exports.Level = {}));
/**
 * Creates a logger that logs events using the given driver and context provider.
 *
 * @param driver the driver that logs events
 * @param getParentContext a provider that returns the context to use for this logger
 *   (the context is returned when messages are logged with the logger)
 * @returns a Logger
 */
const createCoreLogger = (driver, getParentContext) => {
    const context = {};
    const getContext = () => ({ ...getParentContext === null || getParentContext === void 0 ? void 0 : getParentContext(), ...context });
    return {
        logEvent: (level, event) => driver(level, { ...event, context: getContext() }),
        log: (message, level = Level.Info) => driver(level, { message, context: getContext() }),
        setContext: (obj) => { Object.assign(context, obj); },
        createSubContext: () => (0, exports.createCoreLogger)(driver, getContext),
    };
};
exports.createCoreLogger = createCoreLogger;
